import { render, staticRenderFns } from "./ProductChangeLogs.vue?vue&type=template&id=2c727f69"
import script from "./ProductChangeLogs.vue?vue&type=script&lang=js"
export * from "./ProductChangeLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports